import { BLOCK_PATH } from "../const";

export const BLOCK_EDIT_PAGE = "edit";
export const REPORT_EDIT_PATH = `${BLOCK_PATH}/${BLOCK_EDIT_PAGE}`;
